const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/logo.svg"
    width="150px"
    {...props}
  />
);

export default Logo;
